import { FilterGroup } from 'data/filterGroup/filterGroup.types';
import { WithAuditDetails, AuditDetails, Operation } from 'data/types';
import {
  getAuditDetails,
  getAuditFieldInfo,
  AuditService,
  AuditActionType,
} from 'shared/userAudit/audit-constants';

export default function getFilterGroupDataToSubmit(
  filterGroup: FilterGroup,
  originalFilterGroup: FilterGroup | null,
  isAuditEnabled: boolean,
  userId: string,
  userName: string,
  operation: Operation,
): WithAuditDetails<FilterGroup> {
  const body: WithAuditDetails<FilterGroup> = {
    data: filterGroup,
  };

  let actionType = AuditActionType.CF_FTP_INFO_ADD;
  let isEdit = false;
  if (operation === 'UPDATE') {
    actionType = AuditActionType.CF_FTP_INFO_EDIT;
    isEdit = true;
  }

  if (isAuditEnabled) {
    const auditDetails = getAuditDetails(
      isAuditEnabled,
      userId,
      userName,
      getAuditFieldInfo(filterGroup, null, isEdit, originalFilterGroup),
      filterGroup.id,
      AuditService.CF_FTP_INFO,
      actionType,
    );

    body.auditDetails = auditDetails as AuditDetails;
  }

  return body;
}
